import React from "react";
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";

import WithOverlay from "../withOverlayHoc";
import WizardConflictPopupCartItem from "./wizardConflictPopupCartItem";
import WizardConflictPopupButtons from "./wizardConflictPopupButtons";

const WizardConflictPopup = (props) => {

  const {wizardConflictPopupOpened, cartItems, wizardConflictingSteps} = props;

  if (!wizardConflictPopupOpened) {
    return null
  }

  const cartItemsToRemove = cartItems.filter(cartItem => {
    return wizardConflictingSteps.some(confObject => confObject.cartItemId === cartItem.id);
  });

  return (
    <WithOverlay className="overlay--confirm">
      {(hideOverlay) => (
        <div className={"ui-popup conflict-popup"}>
          <div className="ui-popup__header conflict-popup__header">
            <div className="gc-disclaimer__icon"/>
            <span className="conflict-popup__header-title">
              <FormattedMessage id="confirmPopup.updateWizardNotCompatibleCartItemsTitle"/>
            </span>
          </div>
          <div className="ui-popup__body">
            <div className="ui-popup__body-content ui-popup__body-content--full">
              <p className="ui-popup__body-subtitle ui-popup__body-subtitle--red">
                <FormattedMessage id="confirmPopup.updateWizardNotCompatibleCartItemsText"/>
              </p>
              <ul className="apply-popup-list">
                {cartItemsToRemove.map(cartItem => {
                  return <WizardConflictPopupCartItem key={cartItem.id} cartItem={cartItem}/>
                })}
              </ul>
            </div>
          </div>
          <WizardConflictPopupButtons hideOverlay={hideOverlay} cartItemsToRemove={cartItemsToRemove}/>
        </div>
      )}
    </WithOverlay>
  )
}

const mapStateToProps = (store) => {
  const {wizardConflictingSteps, wizardConflictPopupOpened} = store.wizardState;
  const {cartItems} = store.cartState;

  return {
    cartItems,
    wizardConflictingSteps,
    wizardConflictPopupOpened,
  };
};

export default connect(mapStateToProps)(WizardConflictPopup)
